module.exports = __webpack_public_path__ + "06_mole.4c643c27.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer2/06_mole.png
// module id = F9SS
// module chunks = 0